import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import FaqFrame from '../../components/FaqFrame/FaqFrame';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import axiosClient from '../../libs/axiosClient';
import styles from './Faq.module.scss';

export interface IFaqType {
  content: string;
  created_at: string;
  id: number;
  title: string;
  type: string;
}
function Faq() {
  const [selectedCategory, setSelectedCategory] = useState(0);
  const [categoryList, setCategoryList] = useState<object>({});
  const [faqList, setFaqList] = useState<IFaqType[]>([]);
  const { data: faqListQuery } = useQuery<{
    data: IFaqType[];
    faq_type: {
      [key: number]: string;
    };
  }>('faq', () => axiosClient.get('/data/faq').then((res) => res.data.data), {
    staleTime: 60000 * 60 * 24, //1일 캐싱
  });
  useEffect(() => {
    if (!faqListQuery) return;
    setFaqList(faqListQuery.data);
    setCategoryList(faqListQuery.faq_type);
  }, [faqListQuery]);
  const { t, i18n } = useTranslation();
  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.top}>
        <h3 className={styles.title}>{t('faq.1')}</h3>
        <div className={styles.serviceInfo}>
          <span>{t('faq.3')}</span>
          <h4>+82-2-3443-1119</h4>
          {/* <span>1:1 상담톡을 이용해주시면 더욱 빠른 상담이 가능합니다.</span> */}
          <div className={styles.serviceTimeInfo}>
            <span>am 10:00 - pm 18:00</span>
            <span>lunch pm 12:00 - pm 13:00</span>
            <span>{t('faq.2')}</span>
          </div>
        </div>
      </div>
      <div className={styles.categoryListWrap}>
        <h4>{t('faq.5')}</h4>
        <ul className={styles.categoryList}>
          <li
            onClick={() => setSelectedCategory(0)}
            className={selectedCategory == 0 ? styles.hit : ''}
          >
            {t('faq.4')}
          </li>
          {Object.values(categoryList).map((category: string, idx: number) => (
            <li
              key={idx}
              onClick={() => setSelectedCategory(idx + 1)}
              className={selectedCategory == idx + 1 ? styles.hit : ''}
            >
              {category}
            </li>
          ))}
        </ul>
      </div>
      <ul className={styles.faqList}>
        {faqList &&
          faqList
            .filter((faq) => {
              if (selectedCategory == 0) return faq;
              return Number(faq.type) == selectedCategory;
            })
            .map((faq) => (
              <li key={faq.id}>
                <FaqFrame faq={faq} />
              </li>
            ))}
        {faqList &&
          !faqList.filter((faq) => {
            if (selectedCategory == 0) return faq;
            return Number(faq.type) == selectedCategory;
          }).length && (
            <p className={styles.noData}>No registered questions.</p>
          )}
      </ul>
      <Footer />
    </div>
  );
}
export default Faq;
